import { TEXT } from '../../../../helpers/text.constants';

export const BulkBoqEditTextConst = {
	coatingSystem: TEXT.coatingSystem,
	project: TEXT.project,
	targetProjectName: TEXT.targetProjectName,
};
